
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useNavigate } from 'react-router-dom';

export default function MirariEchoCTA() {
  const { ref, isVisible } = useScrollAnimation();
  const navigate = useNavigate();

  return (
    <section ref={ref} className="bg-white py-32 lg:py-40 px-8 lg:px-32">
      <div className="max-w-4xl mx-auto text-center">
        <div
          className={`transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl lg:text-4xl font-medium text-gray-900 mb-6 leading-relaxed">
            あなたの空間に「Echo」を。
          </h2>
          <p className="text-base text-gray-600 leading-relaxed mb-3">
            イベント、展示会、商業施設など、Echoの設置・レンタルに関するご相談はお気軽にお問い合わせください。
          </p>
          <p className="text-sm text-gray-400 leading-relaxed mb-12">
            Looking to create a &quot;wow&quot; moment in your space? Contact us to bring Echo to your next activation.
          </p>

          <div className="flex items-center justify-center gap-6">
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => {
                  const el = document.getElementById('contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 300);
              }}
              className="inline-flex items-center gap-2 px-10 h-14 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              お問い合わせ / Contact
            </button>
            <a
              href="https://mirari.art"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-10 h-14 bg-transparent text-gray-900 text-sm font-medium rounded-full border-2 border-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              mirari.art
              <i className="ri-external-link-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
